import * as React from 'react'
import { useTranslation } from 'react-i18next';
import {
    DefaultButton,
    Modal,
    PrimaryButton,
    Label,
    DatePicker,
    defaultDatePickerStrings,
    TextField
} from '@fluentui/react';
import { Selection } from '@fluentui/react/lib/DetailsList';
import * as Api from "../../../api/src"
import ModalHeader from '../../../control/modalHeader';
import Moment from 'moment';

const MatrixItemsApi = new Api.MatrixItemsApi();
let _selection: Selection | undefined = new Selection({ selectionMode: 1 });

export interface ModalEditModuleProps {
    IsOpen: boolean,
    onCloseModal: () => void;
    onSaveClick: () => void;
    Item: Api.MatrixItemModuleDto | null
}
const ModalEditModule = ({ IsOpen, onCloseModal, onSaveClick, Item }: ModalEditModuleProps) => {
    const { t } = useTranslation();
    const [isShow, SetIsShow] = React.useState(false);
    const [detail, SetDetail] = React.useState<Api.EditMatrixItemModuleCommand>({} as Api.EditMatrixItemModuleCommand);

    React.useEffect(() => {
        if (IsOpen && Item) {
            SetDetail({ MatrixItemModuleId: Item.Id || 0, Deadline: Item.Deadline, Description: Item.Description })
            SetIsShow(IsOpen);
        }
    }, [IsOpen]);

    const onClose = () => {
        onCloseModal()
        SetIsShow(false)
    }
    const onSave = async () => {
        await MatrixItemsApi.apiMatrixItemsMatrixItemModuleIdEditPatch(detail?.MatrixItemModuleId || 0, detail);
        onCloseModal();
        SetIsShow(false);
        onSaveClick();
    }
    return (
        <Modal
            isOpen={isShow}
            isModeless={true}
        >
            <ModalHeader title="Edit Module" onCloseModal={() => {
                onClose();
            }} />
            <div className={'modal-content'} style={{ width: 400 }}>
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-md12">
                            <DatePicker
                                label={t("Deadline")}
                                showWeekNumbers={true}
                                firstWeekOfYear={1}
                                showMonthPickerAsOverlay={true}
                                minDate={new Date()}
                                value={detail?.Deadline ? Moment(detail?.Deadline).toDate() : undefined}
                                placeholder="dd/mm/yyyy"
                                formatDate={(date?: Date): string => {
                                    return Moment(date).format('DD/MM/yyyy');
                                }}
                                onSelectDate={(date: Date | null | undefined) => {
                                    if (date) {
                                        SetDetail({ ...detail, Deadline: date.toISOString() || "" });
                                    }
                                }}
                                strings={defaultDatePickerStrings}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-md12">
                            <TextField label={t("Description")} multiline={true} rows={5} value={detail?.Description || ""}
                                onChange={(e, newValue) => { SetDetail({ ...detail, Description: newValue }); }}></TextField>
                        </div>
                    </div>
                </div>
            </div>
            <div className={'modal-footer'}>
                <DefaultButton className={"margin-left-10"} onClick={() => { onClose(); }} >{t("Close")}</DefaultButton>
                <PrimaryButton className={"margin-left-10"} onClick={() => { onSave(); }}>{t("Save")}</PrimaryButton>
            </div>
        </Modal>
    );
}
export default ModalEditModule;